import React from 'react';
import moment from 'moment';
import * as falso from '@ngneat/falso';
import * as Ink from '@carta/ink';
import scopeEval from 'scope-eval';
import { transform } from '@babel/standalone';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

const scope = { ...Ink, moment, falso };

export const compileJsx = (snippet: string) =>
  transform(snippet, {
    presets: ['react'],
  }).code;

const parseElement = (code: string) => code.trim().replace(/^(?<thing><.*>)$/gs, thing => `<>${thing}</>`);
const wrapper = (code: () => React.ReactElement) => code();

export const RenderCode = ({ code, props = {} }: { code: string; props: Record<string, unknown> }) => {
  falso.seed('ink');
  const isElement = code.trim().charAt(0) === '<';
  const snippet = isElement ? parseElement(code) : code;
  const compiledCode = compileJsx(snippet);
  const scopedCode = scopeEval(compiledCode, {
    ...scope,
    props,
    React,
    Link,
    ThemeProvider,
  });
  return isElement ? scopedCode : wrapper(scopedCode);
};
